import React from 'react';

import { NeedDocs } from '../components/PageElements';

/** components */
import Layout from '../components/common/Layout';

const NeedDocsPage = () => (
  <Layout>
    <NeedDocs />
  </Layout>
);

export default NeedDocsPage;
